// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1F6Ue","header":"MergedInvoice_header__1mxaF"};